/* cwc-user-icon */
:host {
  --cwc-modal-overlay-max-width: 700px;
  --cwc-modal-overlay-max-height: 250px;
  --cwc-modal-overlay-min-width: 700px;
  --cwc-modal-overlay-min-height: 250px;

  cwc-component-modal {
    z-index: 10000;
  }

  .pointer {
    cursor: pointer;
  }

  .wrap {
    display: flex;
    position: relative;
    align-items: center;
    height: auto;
    max-height: 100%;
    aspect-ratio: 1 /1;
  }

  .bubble {
    display: flex;
    position: absolute;
    top: -4px;
    right: -4px;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    transform: translate(5px, -5px);
    border: 1px solid var(--navigation-elements-main-nav-background-color, #fff);
    border-radius: 100%;
    background-color: var(--cwc-user-icon-badge-bg-color, var(--navigation-elements-main-nav-icon-color, #1586c4));

    @media screen and (min-width: 1024px) {
      width: 25px;
      height: 25px;
      border: 2px solid var(--navigation-elements-main-nav-background-color, #fff);
    }

    @supports not (aspect-ratio: 1 / 1) {
      display: none;
    }

    ::slotted(svg) {
      stroke: var(--cwc-user-icon-badge-color, var(--navigation-elements-main-nav-background-color, #fff));
      font-weight: 600;
    }
  }

  .hide {
    display: none !important;
  }

  .buttons {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .button {
    display: flex;
    flex: 1;
    justify-content: center;
    padding: 0.5rem;
  }
}
